import React, { useState, useEffect } from 'react'

import { withRouter } from 'react-router-dom'
import { injectIntl } from 'react-intl'
import ReactTooltip from 'react-tooltip'

import Personalization from '../../components/common/personalization/Personalization'
import DataTable from '../../components/common/dataTable/DataTable'
import DataTableHeader from '../../components/common/dataTable/DataTableHeader'
import DataTableRow from '../../components/common/dataTable/DataTableRow'
import DataTableCol from '../../components/common/dataTable/DataTableCol'
import DataTableHeaderCol from '../../components/common/dataTable/DataTableHeaderCol'
import LoadingSpinner from '../../components/common/spinner/LoadingSpinner'
import MessageFeedback from '../../components/common/messageFeedback/MessageFeedback'
import Icon from '../../components/common/icon/Icon'
import Pager from '../../components/common/pager/Pager'
import { DateMapper } from '../../components/common/dateMapper/DateMapper'
import ModalWrapper from '../../components/common/modal/ModalWrapper'
import SelectedRecipientsModal from '../../components/common/selectedRecipientsModal/SelectedRecipientsModal'
import Tooltip from '../../components/common/tooltip/Tooltip'

import { getEmailSendings, getEmailSendingDetails } from '../../api/beSendApi/BeSendApi'
import { getListDataById } from '../../api/beListApi/BeListApi'
import { getMessageDetails } from '../../api/beEmailMessageApi/BeEmailMessageApi'
import { getSendingTotalCounters, getMessageTotalCounters } from '../../api/statisticsApi/StatisticsApi'
import { getGroupDetails } from '../../api/beRecipientApi/BeRecipientApi'
import { getFilter } from '../../api/beFilterApi/BeFilterApi'

import batchPromises from '../../services/batchPromises'

const PAGE_STATUS_READY = 'PAGE_STATUS_READY'

const PAGE_STATUS_ERROR = 'PAGE_STATUS_ERROR'
const PAGE_STATUS_PARAMS_ERROR = 'PAGE_STATUS_PARAMS_ERROR'

const PAGE_STATUS_LOADING = 'PAGE_STATUS_LOADING'

const initialPageState = {
  pageStatus: PAGE_STATUS_LOADING,
  loadPage: true,
  loadData: false,
  pageSize: 10,
  pageNumber: 1,
  totalItems: 0,
  emptyState: false

}

const initialModalData = {
  Selected: '',
  IncludedGroups: [],
  ExcludedGroups: [],
  AppliedFilters: [],
  ItemsDisable: [],
  Error: false,
  Loading: true,
  LoadingItems: true
}

let timeZoneCode = ''

// http://localhost:1234/frontend/sendreport/listGuid/CACD7F73-2EFC-45CE-9600-913CC7D5CA99/idList/1/idNL/1432
// http://d4x9h.smtpnext.com/frontend/sendreport/listGuid/CACD7F73-2EFC-45CE-9600-913CC7D5CA99/idList/1/idNL/1432

// http://localhost:1234/frontend/sendreport/listGuid/AAFA5375-BCF1-4E06-965A-E3A98B626156/idList/1/idNL/90
// https://d4h1d.smtpnext.com/frontend/sendreport/listGuid/AAFA5375-BCF1-4E06-965A-E3A98B626156/idList/1/idNL/90

const SendReport = ({ match, history, location, intl }) => {
  useEffect(() => {
    ReactTooltip.rebuild()
    return () => {
      ReactTooltip.rebuild()
    }
  }, [])

  const listGuid = match.params.listGuid
  const idList = parseInt(match.params.idList)
  const idMessage = parseInt(match.params.idNL)

  const [pageState, setPageState] = useState(initialPageState)
  const [msgData, setMsgData] = useState('')
  const [data, setData] = useState([])
  const [subject, setSubject] = useState([])
  const [openModal, setOpenModal] = useState(false)
  const [modalData, setModalData] = useState(initialModalData)

  function convertDateUtctoCTZ (dateString) {
    const dateInstance = new Date(dateString)
    // const tmp = new Date(dateInstance.getTime() + dateInstance.getTimezoneOffset() * 60000)
    // debugger
    return DateMapper.toLocalDate(dateInstance, timeZoneCode)
  }

  useEffect(() => {
    if (pageState.loadPage) {
      const search = {
        IdMessages: [idMessage]
      }
      const types = ['EI']
      Promise.all([
        getListDataById(idList, listGuid),
        getMessageDetails(idList, listGuid, idMessage, false),
        getEmailSendings(idList, listGuid, search, 1, 1, false),
        getEmailSendings(idList, listGuid, search, 1, 1, true),
        getMessageTotalCounters(idList, listGuid, idMessage, types, '', '')
      ])
        .then(([listData, msgDett, dateLastSendResp, dateFirstSendResp, totalCounters]) => {
          setSubject(msgDett.Subject)
          timeZoneCode = listData.TimeZoneCode
          setMsgData({
            ListName: listData.Name,
            Subject: msgDett.Subject,
            Notes: msgDett.Notes ? 'ID ' + idMessage + ' - ' + msgDett.Notes : 'ID ' + idMessage,
            Recipients: totalCounters.EI,
            DateLastSend: (dateLastSendResp && (dateLastSendResp.Items.length > 0)) ? DateMapper.datetimeToSTring(convertDateUtctoCTZ(dateLastSendResp.Items[0].StartDateJs)) : '-',
            DateFirstSend: (dateFirstSendResp && (dateFirstSendResp.Items.length > 0)) ? DateMapper.datetimeToSTring(convertDateUtctoCTZ(dateFirstSendResp.Items[0].StartDateJs)) : '-'

          })
          setPageState((prevState) => ({ ...prevState, loadPage: false, loadData: true }))
        })
        .catch(() => {
          setPageState((prevState) => ({ ...prevState, pageStatus: PAGE_STATUS_ERROR, loadPage: false }))
        })
    }
  }, [pageState.loadPage])

  useEffect(() => {
    if (pageState.loadData) {
      const search = {
        IdMessages: [idMessage]
      }

      getEmailSendings(idList, listGuid, search, pageState.pageNumber, pageState.pageSize, false)
        .then((emailSendings) => {
          const getTotalCountersParams = emailSendings.Items.map((send) => ({ idSend: send.Id, idMessage: send.IdMessage }))
          batchPromises(getTotalCountersParams, 10, getTotalCounters).then((batchResult) => {})

          setData(emailSendings.Items)
          setPageState((prevState) => ({ ...prevState, totalItems: emailSendings.TotalItems, pageStatus: PAGE_STATUS_READY, loadData: false, emptyState: emailSendings.TotalItems === 0 }))
        })
        .catch(() => {
          setPageState((prevState) => ({ ...prevState, pageStatus: PAGE_STATUS_ERROR, loadData: false }))
        })
    }
  }, [pageState.loadData])

  function getTotalCounters ({ idSend, idMessage }) {
    return getSendingTotalCounters(idList, listGuid, idMessage, idSend, ['EI'])
      .then((resp) => {
        setData((prevState) => (
          prevState.map((o) => ((o.Id === idSend) ? { ...o, Recipients: resp.EI } : o))
        ))
        return idSend
      })
      .catch(() => {
        setData((prevState) => (
          prevState.map((o) => ((o.Id === idSend) ? { ...o, Recipients: <Icon family='fa' icon='exclamation-triangle' className='text-light' /> } : o))
        ))
        return idSend
      })
  }

  const personalizationProps = {
    idList: idList,
    showLogo: true,
    applyCustomCSS: true
  }

  const propsPager = {
    currentPage: pageState.pageNumber,
    itemsPerPage: pageState.pageSize,
    totalItems: pageState.totalItems,
    onChange: onChangePager,
    ofLabel: intl.formatMessage({ id: 'Load.Pager.Of' }),
    itemsLabel: intl.formatMessage({ id: 'Load.Pager.Items' })
  }

  const propsModal = {
    openModal: openModal,
    size: 'XL',
    closeOnOverlayClick: false,
    onClose: closeModal
  }

  function closeModal () {
    setModalData(initialModalData)
    setOpenModal(false)
  }

  function onChangePager (val) {
    setPageState((prevState) => ({ ...prevState, pageNumber: val.pageNumber, pageSize: val.pageSize, loadData: true, pageStatus: PAGE_STATUS_LOADING }))
  }

  function goToDett (data) {
    history.push('/sendreportdetails/listGuid/' + listGuid + '/idList/' + idList + '/idNL/' + idMessage + '/idSend/' + data.Id)
  }

  function showModal (data) {
    setOpenModal(true)
    setModalData((prevState) => ({ ...prevState, Loading: true }))

    getEmailSendingDetails(idList, listGuid, data.Id)
      .then((resp) => {
        setPageState((prevState) => ({ ...prevState, pageStatus: PAGE_STATUS_READY }))
        const itemsDisable = []
        if (!resp.Groups) itemsDisable.push('IncludedGroups')
        if (!resp.Filtri) itemsDisable.push('AppliedFilters')
        if (!resp.ExcludeGroups) itemsDisable.push('ExcludedGroups')

        setModalData((prevState) => ({
          ...prevState,
          IncludedGroups: resp.Groups ? resp.Groups.split(',').map(o => { return { id: o } }) : [],
          AppliedFilters: resp.Filtri ? resp.Filtri.split(',').map(o => { return { id: o } }) : [],
          ExcludedGroups: resp.ExcludeGroups ? resp.ExcludeGroups.split(',').map(o => { return { id: o } }) : [],
          Error: false,
          Loading: false,
          ItemsDisable: itemsDisable,
          EmptySTate: !resp.Groups && !resp.Filtri && !resp.ExcludeGroups
          // Selected: resp.Groups ? 'IncludedGroups' : resp.ExcludeGroups ? 'ExcludedGroups' : 'AppliedFilters'
        }))

        if (resp.Groups) {
          const ids = resp.Groups.split(',')
          batchPromises(ids, 10, getIncludedGroups).then((batchPromisesbatchResult) => {
            setModalData((prevState) => ({
              ...prevState,
              Selected: 'IncludedGroups',
              LoadingItems: false
            }))
          })
        }
        if (resp.ExcludeGroups) {
          const ids = resp.ExcludeGroups.split(',')
          batchPromises(ids, 10, getExcludedGroups).then((batchResult) => {
            setModalData((prevState) => ({
              ...prevState,
              Selected: resp.Groups ? 'IncludedGroups' : 'ExcludedGroups',
              LoadingItems: false
            }))
          })
        }
        if (resp.Filtri) {
          const ids = resp.Filtri.split(',')
          batchPromises(ids, 10, getAppliedFilters).then((batchResult) => {
            setModalData((prevState) => ({
              ...prevState,
              Selected: resp.Groups ? 'IncludedGroups' : resp.ExcludeGroups ? 'ExcludedGroups' : 'AppliedFilters',
              LoadingItems: false
            }))
          })
        }
      })
      .catch(() => {
        setModalData({
          Error: true,
          Loading: false
        })
      })
  }

  function getIncludedGroups (idGroup) {
    return getGroupDetails(idList, listGuid, parseInt(idGroup))
      .then((resp) => {
        setModalData((prevState) => ({
          ...prevState,
          IncludedGroups: prevState.IncludedGroups.map((o) => ((parseInt(o.id) === parseInt(idGroup)) ? { ...o, text: resp.Name } : o))
        }
        ))
        return idGroup
      })
      .catch(() => {
        setModalData((prevState) => ({
          ...prevState,
          IncludedGroups: prevState.IncludedGroups.map((o) => ((parseInt(o.id) === parseInt(idGroup)) ? { ...o, text: <Icon family='fa' icon='exclamation-triangle' className='text-light' /> } : o))
        }
        ))
        return idGroup
      })
  }

  function getExcludedGroups (idGroup) {
    return getGroupDetails(idList, listGuid, parseInt(idGroup))
      .then((resp) => {
        setModalData((prevState) => ({
          ...prevState,
          ExcludedGroups: prevState.ExcludedGroups.map((o) => ((parseInt(o.id) === parseInt(idGroup)) ? { ...o, text: resp.Name } : o))
        }
        ))
        return idGroup
      })
      .catch(() => {
        setModalData((prevState) => ({
          ...prevState,
          ExcludedGroups: prevState.ExcludedGroups.map((o) => ((parseInt(o.id) === parseInt(idGroup)) ? { ...o, text: <Icon family='fa' icon='exclamation-triangle' className='text-light' /> } : o))
        }
        ))
        return idGroup
      })
  }

  function getAppliedFilters (idFilter) {
    return getFilter(idList, listGuid, parseInt(idFilter))
      .then((resp) => {
        setModalData((prevState) => ({
          ...prevState,
          AppliedFilters: prevState.AppliedFilters.map((o) => ((parseInt(o.id) === parseInt(idFilter)) ? { ...o, text: resp.Name } : o))
        }
        ))
        return idFilter
      })
      .catch(() => {
        setModalData((prevState) => ({
          ...prevState,
          AppliedFilters: prevState.AppliedFilters.map((o) => ((parseInt(o.id) === parseInt(idFilter)) ? { ...o, text: <Icon family='fa' icon='exclamation-triangle' className='text-light' /> } : o))
        }
        ))
        return idFilter
      })
  }

  function reloadPage () {
    setPageState((prevState) => ({ ...initialPageState }))
  }

  // function callbackButtonsGroup (selected) {
  //   setModalData((prevState) => ({ ...prevState, Selected: selected }))
  // }

  function dataTableRowClassName (id) {
    return 'test-sendReportPubb-row_' + id
  }

  const propsSelectedRecipientsModal = {
    includedGroups: modalData.IncludedGroups,
    excludedGroups: modalData.ExcludedGroups,
    appliedFilters: modalData.AppliedFilters,
    closeCallback: closeModal,
    selectedItem: modalData.Selected,
    loading: modalData.Loading,
    emptyState: modalData.EmptySTate,
    error: modalData.Error,
    loadingItems: modalData.LoadingItems
  }

  return (
    <>

      <div className='frontend-wrapper-xl'>
        {(pageState.pageStatus === PAGE_STATUS_LOADING) &&
          <LoadingSpinner />}

        {(pageState.pageStatus === PAGE_STATUS_PARAMS_ERROR) &&
          <MessageFeedback kind='error'>{intl.formatMessage({ id: 'Load.Statistics.ErrorDisplayingReport' })}</MessageFeedback>}

        {(pageState.pageStatus === PAGE_STATUS_ERROR) &&
          <MessageFeedback kind='error'>
            {intl.formatMessage({ id: 'Load.Statistics.ErrorLoadingData' })}
            <a className='frontend-p-left-xs-thin test-sendReportPubb-reloadPage' onClick={reloadPage}>{intl.formatMessage({ id: 'Load.MailupCommon.ReloadData' })}</a>
          </MessageFeedback>}

        {(pageState.pageStatus === PAGE_STATUS_READY) &&
          <>
            <Personalization {...personalizationProps} />
            {/* <Tooltip /> */}
            <div className='frontend-row frontend-row_reset row-flex'>
              <h1><b>{intl.formatMessage({ id: 'Load.SendReportFrontend.SentReport' })}</b></h1>
            </div>
            <div className='frontend-row frontend-row_reset'>
              <div className='col-xs-8 frontend-p-left-0'>
                <div className='frontend-box frontend-p-bottom test-OpenCLickReportPubb-MsgDett'>
                  <h3 className='frontend-m-bottom-x-sm'><b>{intl.formatMessage({ id: 'Load.Statistics.MsgDett' })}</b></h3>
                  <p className='frontend-m-bottom-xx-sm'><strong>{msgData.Subject}</strong></p>
                  <p className='frontend-m-bottom-x-sm'>{msgData.Notes}</p>
                  <p className='frontend-m-bottom-x-sm'>
                    <b>{intl.formatMessage({ id: 'Load.MailupCommon.List' })}:</b>&nbsp;
                    <span>{idList} - {msgData.ListName}</span>
                  </p>
                  <p className='frontend-m-bottom-xx-sm'>
                    <b>{intl.formatMessage({ id: 'Load.Statistics.FirstSend' })}:</b>&nbsp;
                    <span>{msgData.DateFirstSend} {timeZoneCode.split(':')[0]}</span>
                  </p>
                  <p className='frontend-m-bottom-xx-sm'>
                    <b>{intl.formatMessage({ id: 'Load.Statistics.LastSend' })}:</b>&nbsp;
                    <span>{msgData.DateLastSend} {timeZoneCode.split(':')[0]}</span>
                  </p>

                </div>
              </div>
              <div className='col-xs-4 frontend-p-right-0'>
                <div className='frontend-box frontend-p-bottom test-OpenCLickReportPubb-Recipients'>
                  <h2><b>{intl.formatNumber(msgData.Recipients)}</b></h2>
                  <p className='frontend-text-uppercase frontend-note'>{intl.formatMessage({ id: 'Load.Statistics.SelectedRecipients' })}</p>
                </div>

              </div>
            </div>
            {pageState.emptyState
              ? <div className='frontend-box frontend-p-bottom'><h3 className='text-center'>{intl.formatMessage({ id: 'Load.SendReportFrontend.EmptyState' }, { Id: idMessage, Nome: subject })}</h3> </div>
              : <>
                <div className='frontend-box frontend-m-bottom'>
                  <DataTable>
                    <DataTableHeader>

                      <DataTableHeaderCol width='6' className='frontend-p-left-thin'>
                        {intl.formatMessage({ id: 'Load.Statistics.LastSend' })}
                      </DataTableHeaderCol>

                      <DataTableHeaderCol width='4' className='frontend-p-left-thin'>
                        {intl.formatMessage({ id: 'Load.Statistics.Recipient' })}
                      </DataTableHeaderCol>
                      <DataTableHeaderCol width='2' />

                    </DataTableHeader>
                    {data.map((item, index) =>
                      <DataTableRow key={index} className={dataTableRowClassName(item.Id)}>
                        <DataTableCol width='6' className='frontend-p-left-thin'>
                          {DateMapper.datetimeToSTring(convertDateUtctoCTZ(item.StartDateJs))} {timeZoneCode.split(':')[0]}
                        </DataTableCol>

                        <DataTableCol width='4' className='frontend-p-left-thin'>{(item.Recipients || item.Recipients === 0)
                          ? item.Recipients > 0
                            ? <a className='frontend-link-secondary test-SendReportPubb-openModal' onClick={() => showModal(item)}>{intl.formatNumber(item.Recipients)}</a>
                            : <p>{intl.formatNumber(item.Recipients)}</p>
                          : <p className='is-loading' />}
                        </DataTableCol>
                        <DataTableCol width='2' className='frontend-text-right '>
                          <a className='frontend-link-highlight test-SendReportPubb-goToDett' onClick={() => goToDett(item)}>{intl.formatMessage({ id: 'Load.Common.Detail' })}</a>
                        </DataTableCol>
                      </DataTableRow>
                    )}
                  </DataTable>
                  <Pager {...propsPager} />
                </div>

                </>}
          </>}

      </div>

      <ModalWrapper {...propsModal}>
        <Tooltip />
        <SelectedRecipientsModal {...propsSelectedRecipientsModal} />
      </ModalWrapper>
    </>
  )
}

export default injectIntl(withRouter(SendReport))
